"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Article = void 0;
var React = _interopRequireWildcard(require("react"));
var _Article = _interopRequireDefault(require("./Article.css"));
var _uiKit = require("@cian/ui-kit");
var _sliderModalContext = require("../../../../utils/sliderModalContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Article = props => {
  const {
    id,
    imageUrl,
    title,
    url,
    date
  } = props;
  const {
    onArticleClick
  } = (0, _sliderModalContext.useSliderModalContext)();
  return /*#__PURE__*/React.createElement("a", {
    href: url,
    className: _Article.default['wrapper'],
    target: "_blank",
    onClick: () => onArticleClick?.(id),
    rel: "noreferrer noopener"
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    className: _Article.default['image'],
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: _Article.default['text']
  }, /*#__PURE__*/React.createElement("div", {
    className: _Article.default['title']
  }, title), /*#__PURE__*/React.createElement(_uiKit.UIText3, {
    color: "text-secondary-default"
  }, date)));
};
exports.Article = Article;